import { supabase } from "@/integrations/supabase/client";

interface CreditCostRow {
  operation: string;
  model: string;
  variant: string;
  cost: number;
}

export async function fetchAllCreditCosts(): Promise<CreditCostRow[]> {
  const { data, error } = await supabase
    .from("credit_costs")
    .select("operation, model, variant, cost");

  if (error) throw error;
  return data ?? [];
}
